export const seatingPreferenceValues = {
  AISLE: 'AISLE',
  BESIDE: 'BESIDE',
  NO_OPTION: 'NO_OPTION',
  RANDOM: 'RANDOM',
  WINDOW: 'WINDOW'
};
//# sourceMappingURL=seatingPreferenceValues.js.map